import { useGetPaymentMethodsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
import { useGetPaymentMethodsQuery as usePreviewGetPaymentMethodsQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerPreviewDataRpc.hooks';
import { useAppSelector } from '../redux';
import { selectIsPreview, selectPreviewJwt } from '../features/PreviewSlice/PreviewSelectors';
export function usePaymentMethodsData() {
  var _useAppSelector, _data$results;
  const isPreview = useAppSelector(selectIsPreview);
  const previewJwt = (_useAppSelector = useAppSelector(selectPreviewJwt)) !== null && _useAppSelector !== void 0 ? _useAppSelector : '';
  const {
    loading: previewLoading,
    error: previewError,
    data: previewData
  } = usePreviewGetPaymentMethodsQuery({
    variables: {
      previewJwt
    },
    skip: !isPreview
  });
  const {
    loading,
    error,
    data
  } = useGetPaymentMethodsQuery({
    skip: isPreview
  });
  if (isPreview) {
    var _previewData$results;
    return {
      loading: previewLoading,
      error: previewError,
      data: (_previewData$results = previewData === null || previewData === void 0 ? void 0 : previewData.results) !== null && _previewData$results !== void 0 ? _previewData$results : []
    };
  }
  return {
    loading,
    error,
    data: (_data$results = data === null || data === void 0 ? void 0 : data.results) !== null && _data$results !== void 0 ? _data$results : []
  };
}